import { render } from "./WebChatWidget.vue?vue&type=template&id=c82680a2&scoped=true"
import script from "./WebChatWidget.vue?vue&type=script&lang=js"
export * from "./WebChatWidget.vue?vue&type=script&lang=js"

import "./WebChatWidget.vue?vue&type=style&index=0&id=c82680a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82680a2"]])

export default __exports__